import React, { useState, useCallback } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import AsistenteFlotante from '../common/AsistenteFlotante';

export default function Layout({ children, alertasCount = 0 }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const abrir  = useCallback(() => setSidebarOpen(true),  []);
  const cerrar = useCallback(() => setSidebarOpen(false), []);

  return (
    <div style={{ display:'flex', minHeight:'100vh', background:'#F4F6FB' }}>

      {/* Overlay — click fuera cierra */}
      {sidebarOpen && (
        <div
          onClick={cerrar}
          style={{
            position:'fixed', inset:0,
            background:'rgba(0,27,92,0.45)',
            zIndex:198,
            backdropFilter:'blur(3px)',
            cursor:'pointer',
          }}
        />
      )}

      {/* Sidebar drawer */}
      <div style={{
        position:'fixed', top:0, left:0,
        height:'100vh', zIndex:200,
        transform: sidebarOpen ? 'translateX(0)' : 'translateX(-260px)',
        transition:'transform 0.28s cubic-bezier(0.4,0,0.2,1)',
        willChange:'transform',
        visibility: sidebarOpen ? 'visible' : 'hidden',
      }}>
        <Sidebar onClose={cerrar} />
      </div>

      {/* Contenido principal */}
      <div style={{
        flex:1, display:'flex', flexDirection:'column',
        minHeight:'100vh', width:'100%',
      }}>
        <Header alertasCount={alertasCount} onToggleSidebar={abrir} />
        <main style={{ flex:1, padding:'28px 32px' }}>
          {children}
        </main>
      </div>
      <AsistenteFlotante />
    </div>
  );
}